import { useFormContext, useWatch } from 'react-hook-form';
import Button from '../common/Button.component';
import _ from 'lodash';

const ConfirmButton = () => {
  const { control } = useFormContext();
  const values = useWatch({ control });
  const disabled = !_.some(Object.values(values), (item) => item !== null);

  return (
    <Button type='submit' variant='contained' disabled={disabled}>
      Confirm
    </Button>
  );
};

export default ConfirmButton;
